import { App } from 'vue'
import FilePicker from './LpFilePicker.vue'
import './assets/main.scss'

FilePicker.install = (Vue: App) => {
  Vue.component(FilePicker.name, FilePicker)
}

export default FilePicker
